
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/diamonds/[shape]",
      function () {
        return require("private-next-pages/diamonds/[shape].ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/diamonds/[shape]"])
      });
    }
  